import { render, staticRenderFns } from "./choseTopic.vue?vue&type=template&id=c99b476c&"
import script from "./choseTopic.vue?vue&type=script&lang=js&"
export * from "./choseTopic.vue?vue&type=script&lang=js&"
import style0 from "./choseTopic.vue?vue&type=style&index=0&id=c99b476c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports